import { APIFactory } from '../../rest/APIFactory';
import { axiosErrorHandler } from '../../rest/axiosErrorHandler';
import { baseUrlService } from '../../rest/BaseUrlService';
import { transformFromServiceItemToViewItem } from './transformFromServiceItemToViewItem';
import { ICDV3ServiceItem, ICDV3WithDetailsServiceItem } from './ServiceInterfaces';
import { IRefiDiscount } from '../interfaces/IRefiDiscount';
import { ClientUrlFactory } from '../../rest/ClientUrlFactory';
import { ICDV3ItemsResponse } from '../interfaces/ICDV3ItemsResponse';
import { ICDV3ViewItem } from '../interfaces/ICDViewItem';

export const getCDItemsWithDetailsByOwnerId = async (ownerId: string): Promise<ICDV3ItemsResponse | Error> =>
  await APIFactory(baseUrlService.ApiLocation)
    .get<ICDV3WithDetailsServiceItem>(ClientUrlFactory().urlFor.cdItemsWithDetails(ownerId))
    .then((response) => ({
      items: response.data.items.map(transformFromServiceItemToViewItem),
    }))
    .catch(axiosErrorHandler);

export const getCDItemsByOwnerId = async (ownerId: string): Promise<ICDV3ViewItem[] | Error> =>
  await APIFactory(baseUrlService.ApiLocation)
    .get<ICDV3ServiceItem[]>(ClientUrlFactory().urlFor.cdItems(ownerId))
    .then((response) => response.data.map(transformFromServiceItemToViewItem))
    .catch(axiosErrorHandler);

export const getRefiDiscountByState = async (
  state: string,
  fips: string,
  clientName: string
): Promise<IRefiDiscount | Error> =>
  await APIFactory(baseUrlService.ApiLocation)
    .get<IRefiDiscount>(ClientUrlFactory().urlFor.refiDiscountByState(state, fips, clientName))
    .then((response) => response.data as IRefiDiscount)
    .catch(axiosErrorHandler);
